import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue";
const _hoisted_1 = { id: "products" };
const _hoisted_2 = { class: "flex items-center mb-4" };
const _hoisted_3 = {
    key: 0,
    class: "lg:flex"
};
const _hoisted_4 = { class: "lg:w-1/2 lg:mr-2" };
const _hoisted_5 = { class: "w-full h-48" };
const _hoisted_6 = { class: "text-slate-600" };
const _hoisted_7 = { class: "p-2 text-right" };
const _hoisted_8 = ["href"];
const _hoisted_9 = { class: "p-2 text-right" };
const _hoisted_10 = { class: "p-2 text-right" };
const _hoisted_11 = { class: "p-2 text-right" };
const _hoisted_12 = { class: "p-2 text-right" };
const _hoisted_13 = {
    class: "w-full",
    role: "presentation"
};
const _hoisted_14 = { class: "p-2 text-right text-slate-600 font-medium" };
const _hoisted_15 = { class: "lg:w-1/2 lg:mr-2" };
const _hoisted_16 = { class: "w-full h-48" };
const _hoisted_17 = { class: "text-slate-600" };
const _hoisted_18 = { class: "p-2 text-right" };
const _hoisted_19 = { class: "p-2 text-right" };
const _hoisted_20 = { class: "p-2 text-right" };
const _hoisted_21 = { class: "p-2 text-right" };
const _hoisted_22 = { class: "p-2 text-right" };
const _hoisted_23 = { class: "flex items-center mb-4" };
const _hoisted_24 = { key: 0 };
const _hoisted_25 = {
    key: 2,
    class: "grid gap-6 grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4"
};
const _hoisted_26 = { class: "overflow-hidden relative col-span-1 bg-slate-50 rounded-lg shadow divide-y divide-slate-200 rounded-2xl" };
const _hoisted_27 = {
    key: 0,
    class: "absolute top-4 -left-8 bg-brand-500 text-white font-medium text-sm shadow-lg -rotate-45 px-8 py-1 uppercase"
};
const _hoisted_28 = { class: "w-full flex items-center justify-between space-x-6 rounded-t-2xl bg-slate-200 p-2" };
const _hoisted_29 = ["src", "alt"];
const _hoisted_30 = { class: "flex px-5 py-3" };
const _hoisted_31 = { class: "flex-1" };
const _hoisted_32 = { class: "flex sub-heading font-medium text-sm text-slate-700" };
const _hoisted_33 = { class: "text-slate-400 text-xs" };
const _hoisted_34 = { class: "flex items-center" };
const _hoisted_35 = { class: "font-medium text-brand-600 text-center" };
const _hoisted_36 = { class: "my-loading" };
const _hoisted_37 = { class: "no-results panel p-10 mt-4" };
const _hoisted_38 = { class: "text-center mt-4 text-sm text-slate-700" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Loading = _resolveComponent("Loading");
    const _component_ProductSelectionModal = _resolveComponent("ProductSelectionModal");
    const _component_router_link = _resolveComponent("router-link");
    const _component_VueEternalLoading = _resolveComponent("VueEternalLoading");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_2, [
                _cache[1] || (_cache[1] = _createElementVNode("h1", null, "Mange Campaign Products", -1)),
                _createElementVNode("nav", null, [
                    _createElementVNode("button", {
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.form.navigation.goBack())),
                        type: "button",
                        class: "alt"
                    }, "Go Back")
                ])
            ])
        ]),
        (_ctx.form.isLoaded())
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("section", _hoisted_4, [
                    _createElementVNode("table", _hoisted_5, [
                        _cache[9] || (_cache[9] = _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                                _createElementVNode("th", {
                                    class: "text-left font-medium text-slate-800",
                                    colspan: "2"
                                }, "Campaign Details")
                            ])
                        ], -1)),
                        _createElementVNode("tbody", _hoisted_6, [
                            _createElementVNode("tr", null, [
                                _cache[3] || (_cache[3] = _createElementVNode("td", { class: "py-2 text-left text-sm font-medium text-slate-500" }, "Name", -1)),
                                _createElementVNode("td", _hoisted_7, [
                                    _createTextVNode(_toDisplayString(_ctx.form.campaign.data.name) + " <", 1),
                                    _createElementVNode("a", {
                                        href: _ctx.form.campaign.data.endpoint,
                                        class: "text-brand-600 font-medium",
                                        target: "_blank"
                                    }, _toDisplayString(_ctx.form.campaign.data.slug), 9, _hoisted_8),
                                    _cache[2] || (_cache[2] = _createTextVNode(">", -1))
                                ])
                            ]),
                            _createElementVNode("tr", null, [
                                _cache[4] || (_cache[4] = _createElementVNode("td", { class: "py-2 text-left text-sm font-medium text-slate-500" }, "Start Date", -1)),
                                _createElementVNode("td", _hoisted_9, _toDisplayString(_ctx.f.formatDate(_ctx.form.campaign.data.start_date)) + " (" + _toDisplayString(_ctx.f.getTimeZone()) + ")", 1)
                            ]),
                            _createElementVNode("tr", null, [
                                _cache[5] || (_cache[5] = _createElementVNode("td", { class: "py-2 text-left text-sm font-medium text-slate-500" }, "End Date", -1)),
                                _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.form.campaign.data.end_date ? _ctx.f.formatDate(_ctx.form.campaign.data.end_date) + ' (' + _ctx.f.getTimeZone() + ')' : 'No End Date'), 1)
                            ]),
                            _createElementVNode("tr", null, [
                                _cache[7] || (_cache[7] = _createElementVNode("td", { class: "py-2 text-left text-sm font-medium text-slate-500" }, "Status", -1)),
                                _createElementVNode("td", _hoisted_11, [
                                    _createElementVNode("span", {
                                        class: _normalizeClass(["status-box", _ctx.f.statusBox(_ctx.form.campaign.data.status.campaign_status)])
                                    }, [
                                        _createElementVNode("span", null, _toDisplayString(_ctx.form.campaign.data.status.campaign_status), 1),
                                        _cache[6] || (_cache[6] = _createElementVNode("span", null, [
                                            _createElementVNode("span"),
                                            _createElementVNode("span")
                                        ], -1))
                                    ], 2)
                                ])
                            ]),
                            _createElementVNode("tr", null, [
                                _cache[8] || (_cache[8] = _createElementVNode("td", { class: "py-2 text-left text-sm font-medium text-slate-500" }, "Currency", -1)),
                                _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.form.campaign.data.currency), 1)
                            ])
                        ])
                    ]),
                    _cache[11] || (_cache[11] = _createElementVNode("hr", { class: "my-2 border-slate-400" }, null, -1)),
                    _createElementVNode("table", _hoisted_13, [
                        _createElementVNode("tbody", null, [
                            _createElementVNode("tr", null, [
                                _cache[10] || (_cache[10] = _createElementVNode("td", { class: "p-2 text-left text-slate-600" }, "Created", -1)),
                                _createElementVNode("td", _hoisted_14, _toDisplayString(_ctx.f.formatDate(_ctx.form.campaign.data.created_at)) + " by " + _toDisplayString(_ctx.form.campaign.data.user_name), 1)
                            ])
                        ])
                    ])
                ]),
                _createElementVNode("section", _hoisted_15, [
                    _createElementVNode("table", _hoisted_16, [
                        _cache[17] || (_cache[17] = _createElementVNode("thead", null, [
                            _createElementVNode("tr", null, [
                                _createElementVNode("th", {
                                    class: "text-left font-medium text-slate-800",
                                    colspan: "2"
                                }, "Campaign Products")
                            ])
                        ], -1)),
                        _createElementVNode("tbody", _hoisted_17, [
                            _createElementVNode("tr", null, [
                                _cache[12] || (_cache[12] = _createElementVNode("td", { class: "p-2 text-left text-sm font-medium text-slate-500" }, "Campaign Products", -1)),
                                _createElementVNode("td", _hoisted_18, _toDisplayString(_ctx.form.metrics.campaign_products), 1)
                            ]),
                            _createElementVNode("tr", null, [
                                _cache[13] || (_cache[13] = _createElementVNode("td", { class: "p-2 text-left text-sm font-medium text-slate-500" }, "Account Products", -1)),
                                _createElementVNode("td", _hoisted_19, _toDisplayString(_ctx.form.metrics.account_products), 1)
                            ]),
                            _createElementVNode("tr", null, [
                                _cache[14] || (_cache[14] = _createElementVNode("td", { class: "p-2 text-left text-sm font-medium text-slate-500" }, "Active Products", -1)),
                                _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.form.metrics.active_products), 1)
                            ]),
                            _createElementVNode("tr", null, [
                                _cache[15] || (_cache[15] = _createElementVNode("td", { class: "p-2 text-left text-sm font-medium text-slate-500" }, "Inactive Products", -1)),
                                _createElementVNode("td", _hoisted_21, _toDisplayString(_ctx.form.metrics.inactive_products), 1)
                            ]),
                            _createElementVNode("tr", null, [
                                _cache[16] || (_cache[16] = _createElementVNode("td", { class: "p-2 text-left text-sm font-medium text-slate-500" }, "Deleted Products", -1)),
                                _createElementVNode("td", _hoisted_22, _toDisplayString(_ctx.form.metrics.trashed_products), 1)
                            ])
                        ])
                    ])
                ])
            ]))
            : (_openBlock(), _createBlock(_component_Loading, {
                key: 1,
                message: "Loading Campaign"
            })),
        _createElementVNode("div", _hoisted_23, [
            _cache[18] || (_cache[18] = _createElementVNode("h2", { class: "flex-1 font-medium mb-4 text-xl" }, "Products", -1)),
            (_ctx.form.isLoaded() && _ctx.permissions.isProgrammeManager())
                ? (_openBlock(), _createElementBlock("nav", _hoisted_24, [
                    _createVNode(_component_ProductSelectionModal, {
                        account: _ctx.form.account,
                        currency: _ctx.form.campaign.data.currency,
                        onConfirmSelection: _ctx.toggleProductSelection
                    }, null, 8, ["account", "currency", "onConfirmSelection"])
                ]))
                : _createCommentVNode("", true)
        ]),
        _cache[26] || (_cache[26] = _createElementVNode("blockquote", { class: "mb-4 bg-slate-200 p-4 mx-4 border-l-4 border-brand-500" }, [
            _createElementVNode("p", { class: "mx-4 text-sm" }, [
                _createElementVNode("span", { class: "font-medium" }, "Please Note:"),
                _createTextVNode(" By default all products available to your account will be available to purchase for this campaign, selecting one or more products will change this behaviour to disable all products and only show the selected products. ")
            ])
        ], -1)),
        (_ctx.product_index.hasResults())
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.product_index.getData(), (product) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_26, [
                        (product.prepaid)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_27, "Prepaid"))
                            : _createCommentVNode("", true),
                        _createElementVNode("div", _hoisted_28, [
                            _createElementVNode("img", {
                                class: "object-contain h-48 rounded-2xl mx-auto",
                                src: product.image,
                                alt: product.name
                            }, null, 8, _hoisted_29)
                        ]),
                        _createElementVNode("div", _hoisted_30, [
                            _createElementVNode("div", _hoisted_31, [
                                _createElementVNode("h3", _hoisted_32, _toDisplayString(_ctx.f.ellipsis(product.name, 20)), 1),
                                _createElementVNode("p", _hoisted_33, _toDisplayString(_ctx.f.ellipsis(product.sku, 20)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_34, [
                                _createElementVNode("p", _hoisted_35, [
                                    _createElementVNode("span", {
                                        class: _normalizeClass(["status-box", {
                                                'status-active': product.active === true,
                                                'status-cancelled': product.active === false,
                                            }])
                                    }, [
                                        _createElementVNode("span", null, _toDisplayString(product.active ? 'Active' : 'Inactive'), 1)
                                    ], 2)
                                ])
                            ])
                        ])
                    ]));
                }), 256))
            ]))
            : _createCommentVNode("", true),
        _createVNode(_component_VueEternalLoading, { load: _ctx.load }, {
            loading: _withCtx(() => [
                _createElementVNode("div", _hoisted_36, [
                    _createVNode(_component_Loading, { message: "Loading Products" })
                ])
            ]),
            "no-more": _withCtx(() => [...(_cache[19] || (_cache[19] = [
                    _createElementVNode("div", { class: "my-no-more" }, [
                        _createElementVNode("div", { class: "my-6 text-center" }, [
                            _createElementVNode("a", {
                                href: "#products",
                                class: "flex justify-center"
                            }, [
                                _createElementVNode("svg", {
                                    xmlns: "http://www.w3.org/2000/svg",
                                    class: "h-5 w-5 mr-2",
                                    fill: "none",
                                    viewBox: "0 0 24 24",
                                    stroke: "currentColor",
                                    "stroke-width": "2"
                                }, [
                                    _createElementVNode("path", {
                                        "stroke-linecap": "round",
                                        "stroke-linejoin": "round",
                                        d: "M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
                                    })
                                ]),
                                _createTextVNode(" Top of Page ")
                            ])
                        ])
                    ], -1)
                ]))]),
            "no-results": _withCtx(() => [
                _createElementVNode("div", _hoisted_37, [
                    _cache[23] || (_cache[23] = _createElementVNode("div", { class: "text-slate-300 my-6" }, [
                        _createElementVNode("svg", {
                            xmlns: "http://www.w3.org/2000/svg",
                            class: "h-20 w-20 mx-auto",
                            fill: "none",
                            viewBox: "0 0 24 24",
                            stroke: "currentColor",
                            "stroke-width": "2"
                        }, [
                            _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                d: "M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z"
                            })
                        ])
                    ], -1)),
                    _cache[24] || (_cache[24] = _createElementVNode("h2", { class: "text-slate-600 font-medium text-2xl text-center" }, "No Campaign Products Available", -1)),
                    _createElementVNode("p", _hoisted_38, [
                        _cache[21] || (_cache[21] = _createTextVNode(" We could not find any products for this account, please check ", -1)),
                        _createVNode(_component_router_link, {
                            to: { name: 'admin.account.manage', params: { slug: _ctx.account } }
                        }, {
                            default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                                    _createTextVNode("your account", -1)
                                ]))]),
                            _: 1
                        }, 8, ["to"]),
                        _cache[22] || (_cache[22] = _createTextVNode(" has products available. ", -1))
                    ])
                ])
            ]),
            error: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                    _createElementVNode("div", { class: "no-results panel p-10 mt-4" }, [
                        _createElementVNode("div", { class: "text-slate-300 my-6" }, [
                            _createElementVNode("svg", {
                                xmlns: "http://www.w3.org/2000/svg",
                                class: "h-20 w-20 mx-auto",
                                fill: "none",
                                viewBox: "0 0 24 24",
                                stroke: "currentColor",
                                "stroke-width": "2",
                                role: "img",
                                focusable: "false",
                                "aria-label": "An Error Occurred"
                            }, [
                                _createElementVNode("path", {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    d: "M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                                })
                            ])
                        ]),
                        _createElementVNode("h2", { class: "text-slate-600 font-medium text-2xl text-center" }, "An Error Occurred"),
                        _createElementVNode("p", { class: "text-center mt-4 text-sm text-slate-700" }, " An error occurred, please try again. If this problem persists please contact support. ")
                    ], -1)
                ]))]),
            _: 1
        }, 8, ["load"])
    ]));
}
